import { render } from "./Summaryreport.vue?vue&type=template&id=87a82f3e"
import script from "./Summaryreport.vue?vue&type=script&lang=js"
export * from "./Summaryreport.vue?vue&type=script&lang=js"

import "./Summaryreport.vue?vue&type=style&index=0&id=87a82f3e&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__